import axios from "./axios-auth";

const getShippingSearch = (data) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getshippingsearch",
      params: {},
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, "resp from getShippingSearch api");
        resolve(resp);
      })
      .catch(() => {
        console.log("error from getShippingSearch api");
      });
  });

export { getShippingSearch };
